const languageGuess = (window.navigator.languages
	? window.navigator.languages[0]
	: (window.navigator.language || window.navigator.userLanguage));

const language = languageGuess ? languageGuess.split('-')[0].toUpperCase() : 'EN';

export default language;



// WEBPACK FOOTER //
// ./src/utils/browserLanguage/index.js